import { memo } from 'react';
import {
  Stack,
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  Typography,
  Icon
} from 'investira.react.components';
import {
  AtivosChart,
  EmissoresChart,
  SetoresChart,
  GestoresChart
} from '../../../components/organisms';

const Graphs = memo(props => {
  const { isLoading } = props;
  const { ativos = [], emissores = [], gestores = [], setores = [] } = props.data || {};
  const xCharts = [
    {
      key: 'ativos',
      title: 'Tipos de Ativos',
      data: ativos,
      Component: AtivosChart
    },
    {
      key: 'setores',
      title: 'Setores',
      data: setores,
      Component: SetoresChart
    },
    {
      key: 'emissores',
      title: 'Emissores',
      data: emissores,
      Component: EmissoresChart
    },
    {
      key: 'gestores',
      title: 'Gestores',
      data: gestores,
      Component: GestoresChart
    }
  ].filter(xItem => xItem.data.length > 0);

  const xLength = Math.max(xCharts.length, 1);

  return (
    <Stack
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(1, 1fr)',
          md: 'repeat(2, 1fr)',
          lg: `repeat(${xLength}, 1fr)`,
          xl: `repeat(${xLength}, 1fr)`
        },
        justifyContent: 'space-between',
        gap: 1.5
      }}>
      {isLoading ? (
        Array.from({ length: xCharts.length || 4 }).map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width="100%"
            height="260px"
            sx={{ borderRadius: 2 }}
          />
        ))
      ) : (
        <>
          {xCharts.map(xItem => {
            const ChartComponent = xItem.Component;

            return (
              <Card key={xItem.key} sx={{ flexGrow: 1, minHeight: 0 }}>
                <CardHeader
                  title={
                    <Stack direction="row" alignItems="center" gap={2}>
                      <Icon iconName="chart_pizza" color="secondaryLightness" size={21} />
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {xItem.title}
                      </Typography>
                    </Stack>
                  }
                />
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    padding: 0
                  }}>
                  <ChartComponent data={xItem.data} height={400} pieSize={260} />
                </CardContent>
              </Card>
            );
          })}
        </>
      )}
    </Stack>
  );
});

export default Graphs;
